<script lang="ts">
  export let href: string;
</script>

<a 
  target="_blank" 
  {href} 
  class="bg-am-white hover:bg-black text-am-black h-[40px] flex items-center gap-1 px-4 py-2 rounded-full border-[1.5px] border-am-white-60 hover:border-am-white hover:bg-am-black hover:text-am-white transition-all duration-300 ease-in-out !font-semibold"
>
  Watch Demo
  <span 
    class="material-symbols-rounded"
    style="font-size: 20px; font-variation-settings: 'FILL' 0, 'wght' 300;"
  >play_arrow</span>
</a>
